import { render, staticRenderFns } from "./TransactionDetails.vue?vue&type=template&id=b1afa672"
import script from "./TransactionDetails.ts?vue&type=script&lang=js&external"
export * from "./TransactionDetails.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports